import React, { useState } from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import { GridRenderCellParams } from '@mui/x-data-grid';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Popover from '@mui/material/Popover';
import Image from '../../../common/image';
import { SxStyle } from '../../../../types';

const styles: SxStyle = {
  container: {
    borderRadius: 6,
    padding: '2px',
    lineHeight: 0,
  },
  image: {
    width: '270px',
    height: '480px',
    objectFit: 'cover',
    borderRadius: 4,
  },
};

interface Props {
  params: GridRenderCellParams;
}

const StoryListDateAndImage = ({ params }: Props) => {
  const { strings } = useStringsContext();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = !!anchorEl;

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <IconButton onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
        <Avatar
          sx={{ objectFit: 'cover' }}
          variant="rounded"
          src={params.row.thumbnailUrl}
          alt={strings.stories.fieldNameThumbnail}
        />
      </IconButton>
      <div>{params.row.createdAt}</div>
      <Popover
        id="thumbnail-popover"
        sx={{ pointerEvents: 'none' }}
        PaperProps={{ sx: { ...styles.container } }}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Image sx={styles.image} alt="image" src={params.row.thumbnailUrl} />
      </Popover>
    </Stack>
  );
};
export default StoryListDateAndImage;
